/**
 * Niemierko AdaptiveRT: TCD50/TD50, γ50, α/β — общие для всех этапов; a — свой на этап.
 */

export const NIEMIERKO_PER_STAGE_PARAM = 'a';

const GAMMA50_NAMES = new Set(['&gamma;<sub>50</sub>', 'gamma50']);

const SHARED_TCP_NAMES = new Set(['TCD50', 'α/β', 'alpha_beta', ...GAMMA50_NAMES]);

const SHARED_NTCP_NAMES = new Set(['TD50', 'α/β', 'alpha_beta', ...GAMMA50_NAMES]);

function cloneParam(p) {
  return {
    name: p.name,
    value: p.value,
    description: p.description || '',
    type: p.type,
  };
}

function isPerStageParam(name) {
  return name === NIEMIERKO_PER_STAGE_PARAM;
}

export function isSharedTcpParam(name) {
  return SHARED_TCP_NAMES.has(name);
}

export function isSharedNtcpParam(name) {
  return SHARED_NTCP_NAMES.has(name);
}

export function splitTcpParameters(parameters) {
  const shared = [];
  const perStage = [];
  for (const p of parameters || []) {
    if (!p?.name) continue;
    if (isPerStageParam(p.name)) {
      perStage.push(cloneParam(p));
    } else if (isSharedTcpParam(p.name)) {
      shared.push(cloneParam(p));
    }
  }
  return { shared, perStage };
}

export function splitNtcpParameters(parameters) {
  const shared = [];
  const perStage = [];
  for (const p of parameters || []) {
    if (!p?.name) continue;
    if (isPerStageParam(p.name)) {
      perStage.push(cloneParam(p));
    } else if (isSharedNtcpParam(p.name)) {
      shared.push(cloneParam(p));
    }
  }
  return { shared, perStage };
}

/** Объединить общие параметры модели с параметром a этапа для API. */
export function mergeTcpParametersForStage(sharedParameters, stageParameters) {
  return [...(sharedParameters || []), ...(stageParameters || [])];
}

export function mergeNtcpParametersForStage(sharedParameters, stageParameters) {
  return [...(sharedParameters || []), ...(stageParameters || [])];
}
